<template>
  <span>
    <v-text-field
      v-model="model"
      :label="label"
    ></v-text-field>
    {{ description }}
  </span>
</template>

<script>
import { input } from '@/mixins/input'

export default {
  mixins: [ input ],
  computed: {
    rules() {
      let rules = []
      let options = this.field.options.map(a => a)
      if(typeof(options) != 'undefined') {
        if(options.required) {
          rules.push(v => !!v || this.$t('form.input.error.empty'))
        }
        if(options.min_length != null) {
          rules.push(v => v.length >= options.min_length || this.$t('form.input.error.text.min-length'))
        }
        if(options.max_length != null) {
          rules.push(v => v.length <= options.max_length || this.$t('form.input.error.text.max-length'))
        }
      }
      return rules
    }
  }
}
</script>

<style>
</style>
